import { type FC } from 'react'
import classNames from 'classnames'
import styles from './Sparkline.module.scss'

interface SparklineProps {
  values: number[]
  delta?: number | null
}

const WIDTH = 56
const HEIGHT = 18
const PADDING = 2

export const Sparkline: FC<SparklineProps> = ({ values, delta }) => {
  if (values.length < 2) {
    return null
  }
  const min = Math.min(...values)
  const max = Math.max(...values)
  const span = max - min || 1
  const points = values
    .map((value, index) => {
      const x = PADDING + (index / (values.length - 1)) * (WIDTH - 2 * PADDING)
      const y = HEIGHT - PADDING - ((value - min) / span) * (HEIGHT - 2 * PADDING)
      return `${x.toFixed(1)},${y.toFixed(1)}`
    })
    .join(' ')
  return (
    <svg
      width={WIDTH}
      height={HEIGHT}
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
      className={classNames(styles.sparkline, (delta ?? 0) > 0 ? styles.sparklineUp : null, (delta ?? 0) < 0 ? styles.sparklineDown : null)}
      aria-hidden='true'
    >
      <polyline points={points} fill='none' strokeWidth={1.5} strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}
